"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../theme");
var useStyles = (0, _theme.makeStyles)(function () {
  return {
    container: {
      display: 'inline-block'
    },
    wrapper: {
      display: 'flex',
      flexFlow: 'row wrap',
      alignItems: 'center',
      justifyContent: 'center'
    }
  };
}, {
  name: 'DualFlag'
});
exports.useStyles = useStyles;